/**
 * Created by yz on 2017/3/27.
 */
{
    angular.module('interfaceModule')
        .controller('HomeController',HomeController);
    HomeController.$inject = ['$scope',"$state",'utils.constant','FileUploader',
    'utils.uploadManager','utils.common',"utils.currentUser","$interval","requestHandler"];
    function HomeController($scope,$state,constant,FileUploader,
    	uploadManager,common,currentUser,$interval,requestHandler) {
        let vm=this;
        let collect={
            'uploader':null,
            'activate':activate,
            'gotoOrder':gotoOrder,
            'gotostate':gotostate,
            'gotoStationMap':gotoStationMap,

            'areaid':null,
            'areaname':null,

            //广告
            'advertising': true,
            'widthWrap':false,
            'advertisingimg': './../images/bg.jpg',
            'tipSecond': 15,
            'closeAdv':closeAdv,
            'timer': null,

            //穿透事件
            'advertised':advertised,

            'show_area_alert':show_area_alert,

            'notClick': true,
            'gotoImg':gotoImg,
            'goBOCMain':goBOCMain,
            'refreshBalance':refreshBalance,//登录后查询是否充值未到账
            'refreshorderstatus':refreshorderstatus,//登录后查询是否有订单支付过却状态为 未支付
            'curUser':currentUser
        };
        vm.collect=collect;
        activate();

        function show_area_alert() {
            common.alert("请选择打印点")
        }

        function activate(){

            collect.areaid="";
            collect.areaname="";
            vm.collect.curUser.areaid = "";

            console.log("home activate");

            //console.log('定时器时间', collect.tipSecond);
            // console.log('HomeController,activate');
            //获取当前用户：    //要弄清楚监听事件是什么时候开始触发的？？
            if(currentUser.info){
                //console.log('home页面当前用户信息',currentUser.info);
                collect.userInfo=currentUser.info;
            }else{
                $scope.$on('user.logged',function(event,data){
                    //console.log("这个event是什么：",event);
                   // console.log('home页面监听用户信息');
                   // console.log('user.logged',data);
                    collect.userInfo=data;
                    $scope.userinfo=data;
                    if($scope.userinfo.groupname==="企业管理用户"){
                        //$state.go('main.company',{'userId':$scope.userinfo.userId});
                    }else if($scope.userinfo.groupname==="合作伙伴"){
                        //$state.go('main.partner',{'userId':$scope.userinfo.userId});
                    }
                })
            }
            requestHandler.simpleRequest(constant.action.getUserId).then(function (respone) {
                if(respone.data[0].result==1){
                    collect.userId=respone.data[0].loginuserid;
                    collect.areaid=respone.data[0].areaid;
                    collect.areaname=respone.data[0].areaname;

                    if (collect.areaid == null)
                    {
                        collect.areaid = "";
                    }

                    //currentUser.areaid = collect.areaid;
                    vm.collect.curUser.areaid = collect.areaid;

                    console.log("areaid:" + collect.areaid);
                    console.log("curUser.areaid:" + vm.collect.curUser.areaid);

                    //console.log("当前登录用户id",collect.userId);
                    refreshBalance();
                    refreshorderstatus();
                }else{
                    $state.go('login');
                }

            })

        	uploadManager.init();
        	collect.uploader=uploadManager.uploader;
        	let delegate={};
            //上传文件之前：
            delegate.onBeforeUploadItem = function(fileItem) {
                //console.log('上传文件信息：',fileItem);
            };
            delegate.onWhenAddingFileFailed = function(item , filter, options) {
                //添加文件到上传丢列失败  的回调函数
                common.prompt('文件上传失败，请确认所传文件是否符合要求');
            };

            delegate.onAfterAddingFile = function(fileItem) {
                //成功添加文件到上传队列后
                console.log('上传文件信息：',fileItem);
                $state.go('main.uploading');
            };
        	uploadManager.callbackDelegateList.push(delegate);

            $scope.$on("$destroy", function(e) {
                // console.log("$destroy",$scope==e.targetScope);
                // if($scope==e.targetScope){
                    uploadManager.callbackDelegateList
                        .splice(uploadManager.callbackDelegateList.indexOf(delegate),1);
                    delegate=null;
                // }
                
            });

            $scope.$on("$destroy", function(e){
                $interval.cancel(collect.timer);
            })

        }

        function gotoOrder(){
            $state.go('main.order');
        }

        function gotoStationMap(){
            $state.go('main.stationMap');
        }

        //关闭广告
        function closeAdv(){
            //console.log('点击关闭广告');
            collect.advertising = false;
            collect.widthWrap = true;
        }

        collect.timer = $interval(function(){
            collect.tipSecond = collect.tipSecond -1 ;
            if(collect.tipSecond <= 0){
                collect.advertising = false;
                collect.widthWrap = true;
                $interval.cancel(collect.timer);
            }
        },1000)


        function advertised(event){
            console.log('广告点击事件2',event);
            event.stopPropagation();

        }

        function gotostate(){
           // console.log('进去公告页面');
            $state.go('main.proclamation');
        }
        function gotoImg() {
            $state.go('main.uploadImage');
        }
        function goBOCMain() {
            var form = $("<form></form>");
            form.attr('action','https://mp.weixin.qq.com/s/lQjPmnT-pJMvJjWclKcjwA');
            form.attr('method','get');
            //form.attr('target','_blank');
            form.appendTo("body");
            form.css('display','none');
            form.submit();
        }
        function refreshBalance() {
            let data = [{
                'userid':collect.userId
            }];
            let param = "transaction=" + JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.balancetransactioncheck,param,function(response){
                //console.log("刷新余额后：",response);
            });

        }
        function refreshorderstatus() {
            let data = [{
                'userid':collect.userId,
                'operation':1
            }];
            let param = "payinfo=" + JSON.stringify(data);
            requestHandler.simpleRequest(constant.action.orderpayquery,param,function(response){
                //console.log("刷新订单后：",response);
            });
        }
    }

}